import {connect} from 'react-redux';
import CollegeList from './college-list';
import {bindActionCreators} from 'redux';
import {toggleFollowCollege} from 'shared/college-profile/actions/college-profile';

const mapDispatchToProps = (dispatch) => {
  const basicActions = bindActionCreators(
    {
      toggleFollowCollege,
    },
    dispatch
  );

  const otherActions = {
    followCollege(id) {
      dispatch(toggleFollowCollege(id, 'follow'));
    },
    unfollowCollege(id) {
      dispatch(toggleFollowCollege(id, 'unfollow'));
    },
  };

  return {
    ...basicActions,
    ...otherActions,
  };
};

export default connect(null, mapDispatchToProps)(CollegeList);
